export default __webpack_public_path__ + "477125790b738ce712e9e4d187142f8a.png";